import { Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { ConfirmOutput } from '../../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../../shared/static/common-functions';
import { GlobalsService } from '../../../shared/services/globals.service';

import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../../shared/models/GItem';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { EmployeeService } from '../../../shared/services/employee.service';
import * as _ from 'lodash';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseAppMComponent } from '../../../shared/base-components/base-app-m.component';
import { DQOIReferenceDataQuery } from '../../../dqoi/state/dqoi-reference-data.query';
import { CommonValues } from '../../../shared/static/CommonValues';
import { UnionBus } from '../../../shared/models/UnionBus';
import { UnionXrefsComponent } from './union-xref/union-xref.component';
import { UnionJobRoleXrefBus } from '../../../shared/models/UnionJobRoleXrefBus';
import { EmployeeReference } from '../../../shared/models/employeeReference';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'unions-dialog',
    templateUrl: './unions-dialog.component.html',
    styleUrls: ['./unions-dialog.component.scss'],
    standalone: false
})
export class UnionsDialogComponent extends BaseAppMComponent<UnionBus, EmployeeService, null, null> {
    @ViewChild("unionXref") public unionXref: UnionXrefsComponent;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, public svc_data: EmployeeService, qry_rd: DQOIReferenceDataQuery, ) {
        super(globals, featureFlagService, qry_rd);

    }
    public editForm: UntypedFormGroup
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    saving: boolean = false;
    active: boolean = false;
    data: any;
    gridData: UnionBus[];
    action1: CRUDActions;
    techId: string;
    assignmentDateTime: Date;
    code: string;
    unionJobRoleXrefs: UnionJobRoleXrefBus[] = [];
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();

    @Input() employeeReferenceData: EmployeeReference;

    @Input() sublings: GItem[] =[];
    statusList: GItem[] = []
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action1 = CRUDActions.None;

    }
    ok() {
        this.save();
    }

    save() {
        let user = this.globals.user;

        let busObj: UnionBus = new UnionBus();
        busObj.unionName = this.editForm.controls["unionName"].value;
        busObj.unionId = this.editForm.controls["unionId"].value;
        if (!busObj.unionId) { busObj.unionId = CommonValues.Guid_Empty }
        busObj.insertDt = new Date(Date.now());
        busObj.updateDt = new Date(Date.now());
        busObj.insertUserId = user.userid;
        busObj.updateUserId = user.userid;
        if (CommonFunctions.hasValue(this.unionXref)) {
            busObj.unionJobRoleXrefs = _.cloneDeep(this.unionXref.getChanged());
            busObj.addDeletedItems(this.unionXref.getDeletedItems());
        }
        this.svc_data.saveUnion(busObj).subscribe(data => {
            let result: ConfirmOutput = {
                action: this.action1, dialogResult: CPDialogResult.ok, data: {refresh:true}, code: this.code
            }
            this.confirmation.emit(result);
            this.hide();
        },
            err => { this.CallFailed(err) }
        );

    }

    CallFailed(err) {

        this.saveError(err)

    }
    cancel() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any) {
        this.createForm();
        this.active = true;
        this.unionJobRoleXrefs = [];
        this.svc_data.getUnions().subscribe(data => {
            this.gridData = _.cloneDeep(data);
        });

    }
    public selectionChange(value: any): void {
        if (value) {

            this.editForm.patchValue({
                unionName: value.unionName,
            });
            let index: number = 0;
            let arr: UnionJobRoleXrefBus[] = [];
            var unionJobRoleXrefs = value.unionJobRoleXrefs;
            for (let i = 0; i < value.unionJobRoleXrefs.length; i++) {
                    arr.push(new UnionJobRoleXrefBus(value.unionJobRoleXrefs[i]));
             }
            this.unionJobRoleXrefs = arr;
        }
        else {

            this.editForm.patchValue({
                unionName: '',
            });
            this.unionJobRoleXrefs = [];
        }

    }
    createForm() {
        this.editForm = new UntypedFormGroup({
                'unionId': new UntypedFormControl(''),
            'unionName': new UntypedFormControl('', Validators.required),

            });}
}

